<template>
	<div>
		<div class="video_xx" v-show="!show">
			
		</div>
  	<div class="phone_company_profile_head">
  		<div class="phone_company_video" v-show="!show">
			  <video id="my_video_2" class="video-js vjs-default-skin vjs-fluid myvideo" loop preload="auto" width="100%" poster="" data-setup="{}">
					<source src="../assets/company_profile.mp4" type='video/mp4'>
					<source src="" type='video/webm'>
						您的浏览器版本过低不支持 video 标签。
				</video>
		  </div>
			<img class="phone_company_profile_logo" src="../assets/logo_first.png" alt="">
			<p v-if="lang" class="ch_phone_title">用玩的态度探索全新生活方式</p>
			<p v-else class="english">Explore new ways of life with playful attitude</p>
		</div>
		<div class="phone_company_card_1">
			<p>
				<span v-if="lang">关于放学嗨</span>
				<span v-else class="english">About Afterschool</span>
			</p>
			<p>
				<span v-if="lang">
					放学嗨成立于<span class="english">2016</span>年，涵盖演出现场、新媒体、音乐出版、艺人经纪、视觉设计、影像制作、电子商务七大版块，此外业务还延伸至潮流展、嘉年华、服饰设计等多个领域。旗下拥有国内首届嘻哈音乐节<span class="english">AYO！</span>嘻哈音乐节和嘻哈音乐厂<span class="english">AFSC</span>。通过嘻哈音乐作为切入点，进而影响并引领中国青年文化，为中国音乐产业的发展创造良好的环境。
				</span>
				<span v-else class="english">
					Afterschool, founded in 2016, coversseven sections that the show, new media, music releasing, artist managing, visual design, video production, and electronic commerce. In addition, the business extends to many fields, such as the fashion exhibition, the carnival, the dress design and so on. We haveAYO！HipHop Music Festival that the first HipHop music festival in China! and hip-hop music Label AFSC. Through hip-hop music, it will further influence and guide Chinese youth culture and create a good environment for the development of China's music industry.
				</span>
			</p>
			<p>
				<span v-if="lang">
					目前，放学嗨成功举办两届<span class="english">AYO！</span>嘻哈音乐节，以及<span class="english">Livehouse</span>、艺人巡演等演出；<span class="english">AFSC</span>厂牌拥有法老、<span class="english">TOY</span>王奕、<span class="english">Lil Jet</span>、王愚、<span class="english">HA$</span>五组艺人，都是国内非常具有影响力的艺术家。
				</span>
				<span v-else class="english">
					At present,Afterschool has successfully held two AYO! Hiphop Music Festival, as well as the Livehouse, the artist tour, and so on. The Label AFSC owns five groups of artists, Pharaoh, TOY Wong, Lil Jet, Wang Yu and HA$.
				</span>
			</p>
		</div>
		<div id="phone_card2" class="phone_company_card_2">
			<p>
				<span v-if="lang">旗下品牌</span>
				<span class="english" v-else>Brands</span>
			</p>
			<div class="phone_company_card_logo clear">
				<div class="phone_company_card_logo_1">
					<div class="clear"><img src="../assets/card_logo_1.png" alt=""></div>
					<div class="clear phone_company_card_thing">
						<span v-if="lang">
							<span class="english">AYO！</span>音乐节，是中国首个嘻哈音乐节，已成功举办2届，是目前国内最大型的嘻哈音乐节
						</span>
						<span v-else class="english">
							AYO! Music Festival, the first hip hop festival in China, has been successfully held for 2 times. It is the largest hip-hop festival in China.
						</span>
					</div>
				</div>
				<div class="phone_company_card_logo_2">
					<div><img src="../assets/card_logo_2.png" alt=""></div>
					<div class="phone_company_card_thing">
						<span v-if="lang">
							<span class="english">AFSC</span>厂牌,专注于<span class="english">HIPHOP</span>音乐，打造亚洲最具独特<span class="english">HIPHOP</span>厂牌
						</span>
						<span v-else class="english">
							Label AFSC, focus on HIPHOP music, build the most unique hiphop Label in Asia.
						</span>
					</div>
				</div>
			</div>
		</div>
		<div id="phone_card3" class="phone_company_card_3">
			<p>
				<span v-if="lang">我们的业务</span>
				<span v-else class="english">
					Our business
				</span>
			</p>
			<div class="phone_company_card_logo2 clear">
				<div>
					<div class="clear"><img src="../assets/service_logo_1.png" alt=""></div>
					<div class="clear">
						<span v-if="lang">
							音乐节合作
							<br>
							中小型活动服务
							<br>
							团队建设
						</span>
						<span v-else class="english">
							Music Festival Cooperation
							<br>
							Activity Service
							<br>
							Team Building
						</span>
					</div>
				</div>
				<div>
					<div><img src="../assets/service_logo_2.png" alt=""></div>
					<div>
						<span v-if="lang">
							票务代理
							<br>
							媒体推广
							<br>
							平面&视频制作
						</span>
						<span v-else class="english">
							Ticket Agent
							<br>
							Media Promotion
							<br>
							Picture&Vedio Production
						</span>
					</div>
				</div>
				<div>
					<div><img src="../assets/service_logo_3.png" alt=""></div>
					<div>
						<span v-if="lang">
							艺人<span class="english">Booking</span>
							<br>
							艺人合作
						</span>
						<span v-else class="english">
							Artists Booking
							<br>
							Artists Cooperation
						</span>
					</div>
				</div>
			</div>
			<p>
				<span v-if="lang">
					业务联系，请发送邮件至：<br /><span class="english">info@fangxuehai.cc</span>
				</span>
				<span v-else class="english">
					Business contact , please send email to: <br />info@fangxuehai.cc
				</span>
			</p>
		</div>
		<div  id="phone_card4" class="phone_company_card_4">
			<p>
				<span v-if="lang">加入我们</span>
				<span class="english" v-else>Join us</span>
			</p>
			<div><img src="../assets/logo_first.png" alt=""></div>
			<div>
				<span v-if="lang">
					加入放学嗨，请发送简历至：<br />	<span class="english">marco@fangxuehai.cc</span>
				</span>
				<span v-else class="english">
					Join Afterschool, please send email to: <br />marco@fangxuehai.cc
				</span>
			</div>
		</div>
		<div class="company_card_5">
			<p v-if="lang">派嗨拜浪 ( 上海 ) 网络科技有限公司版权所有<br />©2016【 沪ICP备16032276号 】</p>
	    <p v-else class="english">PAIHAIBAILANG (SHANGHAI) NETWORK TECHNOLOGY CO., LTD. All rights reserved<br />©2016[Shanghai ICP no. 16032276]</p>
	    <p v-if="lang">本网站由派嗨拜浪 ( 上海 ) 网络科技有限公司提供</p>
	    <p v-else class="english">This website is provided by PAIHAIBAILANG (SHANGHAI) NETWORK TECHNOLOGY CO., LTD</p>
		</div>
	</div>
</template>

<script>
	import videojs from 'video.js'
	import 'video.js/dist/video-js.css'

	export default {
  	props:["lang"],
	  data () {
	    return {
	      msg: '11',
	      myPlayer2: '',
	      show: true
	    }
	  },
	  methods: {
	  	play2 () {
	  		console.log(this.myPlayer2.play())
	  		this.myPlayer2.play();
	  		this.logo_show = false;
	  		if (this.IsPC()) {
	    		this.show = false
	    		console.log(this.show)
	    	}
	  	},
	    IsPC () {
	      var userAgentInfo = navigator.userAgent;
	      var Agents = ["iPhone","Windows Phone"];
	      var flag = true;
	      for (var v = 0; v < Agents.length; v++) {
	        if (userAgentInfo.indexOf(Agents[v]) > 0) {
	          flag = false;
	          break;
	        }
	      }
	      return flag;
	    }
	  },
	  mounted () {
	  	if(document.getElementById('phoneayo_icon')) {
	  		document.getElementById('phoneayo_icon').style.display = "inline-block";
		    document.getElementById('phoneayo_icon_2').style.display = "none";
		    document.getElementById('phoneafsc_icon').style.display = "inline-block";
		    document.getElementById('phoneafsc_icon_2').style.display = "none";
	  		console.log(document.getElementById('phoneayo_icon'))
	  	}else {
	  		setTimeout(() => {
          document.getElementById('phoneayo_icon').style.display = "inline-block";
			    document.getElementById('phoneayo_icon_2').style.display = "none";
			    document.getElementById('phoneafsc_icon').style.display = "inline-block";
			    document.getElementById('phoneafsc_icon_2').style.display = "none";
        },1);
	  	}
	  	
			this.myPlayer2 = videojs(document.getElementById('my_video_2'));
	  }
	}
</script>

<style lang="less" scoped>

	.video_xx {
		height: 4rem;
		background-color: #000000;
  }

	.phone_company_profile_head {
		width: 100%;
		font-family: Heavy;
		background-image: url(../assets/phone_company_bg.jpg);
		background-size: 100% 100%;
		padding: 8rem 0 9rem 0;
		position: relative;
		.phone_company_profile_logo {
			margin: 0 0 2rem 0;
			width: 50%;
		}
		&>div {
			text-align: center;
		}
		&>div>img {
			width: 16%;
		}
		p {
			margin-top: 3%;
			font-size: 0.8rem;
			font-family: Heavy;
			letter-spacing: 0.1rem;
			margin: 1.7rem 0 0 0;
			color: #FFFFFF;
		}
		.ch_phone_title {
			letter-spacing: .5rem;
		}
	}

	.phone_company_card_1 {
		background-color: #000000;
		color: #FFFB00;
		padding: 1rem 0 0 0;
		p {
			margin: 0 auto;
			width: 80%;
		}
		p:nth-child(1) {
			color: #FFFB00;
			padding-top: 1rem;
			padding-bottom: 1rem;
			font-family: Heavy;
			font-size: 1.6rem;
			text-align: center;
			letter-spacing: 0.15rem;
			font-weight: bold;
		}
		p:nth-child(n+2) {
			color: #E7E300;
			font-size: .8rem;
			text-align:justify;
			letter-spacing: 0.1rem;
			font-family: Regular;
			line-height: 1.3rem;
		}
		p:nth-child(3) {
			margin-top: 1rem;
			padding-bottom: 1.7rem;
		}
		.english {
			letter-spacing: 0.02rem;
		}
	}
	
	.phone_company_card_2 {
		background-color: #FFFB00;
		color: #000000;
		padding: 1rem 0 0 0;
		p {
			margin: 0;
			width: 100%;
			color: #000000;
			padding-top: 1rem;
			padding-bottom: 2rem;
			font-family: Heavy;
			font-size: 1.6rem;
			text-align: center;
			letter-spacing: 0.15rem;
			font-weight: bold;
		}
	}
	
	.phone_company_card_logo {
		display: flex;
		padding: 0 1rem 4rem 1rem;
		&>div {
			width: 50%;
			img {
				width: 50%;
				margin: 1rem 0 1rem 0;
			}
			.phone_company_card_thing {
				width: 66%;
				margin: 0 auto;
				font-family: Regular;
				letter-spacing: 0.1rem;
				line-height: 1.3rem;
				letter-spacing: 0.1rem;
				font-size: .8rem;
				text-align:justify;
				color: #000000;
				.english {
					letter-spacing: 0.01rem;
				}
			}
		}
	}
	.phone_company_card_3 {
		background-color: #000000;
		color: #FFFB00;
		padding: 1rem 0 4rem 0;
		font-family: Heavy;
		&>p:first-child {
			color: #FFFB00;
			padding-top: 1rem;
			padding-bottom: 1rem;
			font-size: 1.6rem;
			text-align: center;
			letter-spacing: 0.15rem;
			font-weight: bold;
		}
		&>p:last-child {
			line-height: 1.3rem;
			letter-spacing: 0.1rem;
			font-size: 1.2rem;
			text-align:center;
			color: #FFFB00;
		}
	}
	.phone_company_card_logo2 {
		line-height: 1.8rem;
		letter-spacing: 0.1rem;
		font-size: 1.0rem;
		text-align:center;
		color: #FFFB00;	
		font-weight: bold;
		&>div:nth-child(1) {
			margin: 4rem 0 4rem 0;
			img {
				width: 60%;
			}
		}
		&>div:nth-child(2) {
			margin: 0 0 4rem 0;
			img {
				width: 40%;
			}
		}
		&>div:nth-child(3) {
			margin: 0 0 3rem 0;
			img {
				width: 60%;
			}
		}
	}
	
	.myvideo {
		position: absolute;
		width: 100%;
		height: 100%;
		top: 0;
		left: 0;
	}
	
	.phone_company_card_4 {
		background-color: #FFFB00;
		color: #000000;
		padding: 1rem 0 2rem 0;
		p {
			margin: 0;
			width: 100%;
			color: #000000;
			padding-top: 1rem;
			padding-bottom: 2rem;
			font-family: Heavy;
			font-size: 1.6rem;
			text-align: center;
			letter-spacing: 0.15rem;
			font-weight: bold;
		}
		img {
			width: 70%;
			margin: 5rem 0 6rem 0;
		}
		div {
			line-height: 1.3rem;
			letter-spacing: 0.1rem;
			font-size: 1.2rem;
			font-family: Heavy;
			font-weight: bold;
			text-align:center;
			color: #000000;
		}
	}
	.company_card_5 {
		width: 100%;
		background-color: #FFFB00;
		padding: 4rem 0rem 2rem 0rem ;
		p {
			width: 96%;
			margin: 0 auto;
			color: #000000;
			font-family: Regular;
			font-size: .8rem;
			text-align: center;
		}
	}
</style>


// WEBPACK FOOTER //
// src/components/phone_company.vue